import { defineAsyncComponent } from "vue";
export default [
  {
    name: "AssessmentViewCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AssessmentViewEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AssessmentViewSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "module/:moduleUuid/section/:sectionId",
    props: true,
  },
  {
    name: "AssessmentViewSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "module/:moduleUuid/section/:sectionId/end",
    props: true,
  },
  {
    name: "AssessmentViewActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "AssessmentViewCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "AssessmentViewConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "AssessmentViewModulePlan",
    component: defineAsyncComponent(
      () => import("@modules/teacher-view-module-plan/CoursePlanAttempt.vue"),
    ),
    path: "module-plan",
    props: true,
  },
  {
    path: "not-found",
    name: "AssessmentViewNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
